import { createAction } from '../../../store.model';
import { TemplateConfig } from '../../core/config.scorecard.model';
import { ScorecardGridOptions } from '../../core/scorecard-grid-options.model';
import {
    PillarAndMetricResult,
    ScorecardAttributes,
    ScorecardDto,
} from '../../scorecard.model';

import { DirectReportContributionResult } from './direct-report-contribution-grid.model';
import { DirectReportRankResult } from './direct-report-rank-grid.model';

export enum ActionType {
    SCORECARD_GRID__RELOAD = 'SCORECARD_GRID__RELOAD',
    SCORECARD_GRID__PERFORMANCE__SORT = 'SCORECARD_GRID__PERFORMANCE__SORT',
    SCORECARD_GRID__RESET = 'SCORECARD_GRID__RESET',
    DIRECT_REPORT_RANK__SORT = 'DIRECT_REPORT_RANK__SORT',
}

export interface Reload {
    options: ScorecardGridOptions;
    tplConfig: TemplateConfig;
    header: ScorecardDto;
    data: PillarAndMetricResult[];
    attributes: ScorecardAttributes[];
    directReportContributionGrid?: DirectReportContributionResult[];
    directReportRankGrid?: DirectReportRankResult[];
}

export const reload = createAction<ActionType, Reload>(
    ActionType.SCORECARD_GRID__RELOAD,
);

/// ///////

export interface SortPerformanceGrid {
    columnId: string;
}

export const sortPerformanceGrid = createAction<
    ActionType,
    SortPerformanceGrid
>(ActionType.SCORECARD_GRID__PERFORMANCE__SORT);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GridReset {}

export const gridReset = createAction<ActionType, GridReset>(
    ActionType.SCORECARD_GRID__RESET,
);
